var _path, _path2, _path3, _path4, _g, _g2, _g3, _g4, _g5, _g6, _defs, _rect, _g7, _defs2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBfidDocumentFlash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 67,
    viewBox: "0 0 105 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.656 47L103.656 55.6555C103.656 61.1783 99.1791 65.6555 93.6562 65.6555L85.0008 65.6555",
    stroke: "#E4E4E4",
    strokeWidth: 0.932773
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85 1L93.6555 1C99.1783 1 103.655 5.47715 103.655 11V19.6555",
    stroke: "#E4E4E4",
    strokeWidth: 0.932773
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 19.6555L1 11C0.999999 5.47715 5.47715 0.999994 11 0.999994L19.6555 0.999993",
    stroke: "#E4E4E4",
    strokeWidth: 0.932773
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6562 65.6555L11.0008 65.6555C5.47794 65.6555 1.00079 61.1783 1.00079 55.6555L1.00079 47",
    stroke: "#E4E4E4",
    strokeWidth: 0.932773
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bf_212_3127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5606 23.9653C14.0743 16.6018 20.5844 11.1273 27.9269 11.8842L61.1523 15.3095C62.3779 15.4359 63.6153 15.3881 64.8275 15.1677L75.1051 13.2991C83.1212 11.8416 90.5 17.9998 90.5 26.1472V38.9427C90.5 45.5411 85.5778 51.1027 79.0284 51.9047L66 53.5H25.5016C17.9316 53.5 11.9476 47.084 12.4745 39.5323L13.5606 23.9653Z",
    fill: "url(#paint0_linear_212_3127)",
    fillOpacity: 0.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_212_3127)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.16797,
    y: 6.0144,
    width: 91,
    height: 55,
    rx: 8,
    fill: "url(#paint1_linear_212_3127)",
    fillOpacity: 0.15
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_212_3127)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3789 23.5222C50.3789 22.6938 51.0505 22.0222 51.8789 22.0222H82.2194C83.0478 22.0222 83.7194 22.6938 83.7194 23.5222C83.7194 24.3506 83.0478 25.0222 82.2194 25.0222H51.8789C51.0505 25.0222 50.3789 24.3506 50.3789 23.5222Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_212_3127)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8789 32.0522C50.8789 31.4999 51.3266 31.0522 51.8789 31.0522H82.2194C82.7717 31.0522 83.2194 31.4999 83.2194 32.0522C83.2194 32.6045 82.7717 33.0522 82.2194 33.0522H51.8789C51.3266 33.0522 50.8789 32.6045 50.8789 32.0522Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_212_3127)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8789 40.1083C50.8789 39.556 51.3266 39.1083 51.8789 39.1083H71.1427C71.695 39.1083 72.1427 39.556 72.1427 40.1083C72.1427 40.6606 71.695 41.1083 71.1427 41.1083H51.8789C51.3266 41.1083 50.8789 40.6606 50.8789 40.1083Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_212_3127)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1932 31.1099C30.3345 31.0972 30.4886 31.0972 30.617 31.1099C33.6736 31.0088 36.1008 28.5446 36.1136 25.5117C36.1136 22.4156 33.558 19.9008 30.4116 19.9008C27.2523 19.9008 24.7095 22.4156 24.7095 25.5117C24.7095 28.5446 27.1367 31.0088 30.1932 31.1099ZM24.1957 43.1908C21.0878 41.1563 21.0878 37.8201 24.1957 35.7729C27.7402 33.4603 33.5322 33.4603 37.051 35.7729C40.1589 37.8075 40.1589 41.1436 37.051 43.1908C33.5193 45.516 27.7274 45.516 24.1957 43.1908Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bf_212_3127",
    x: 3.11441,
    y: 2.48651,
    width: 96.7133,
    height: 60.3412,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 4.66387
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_212_3127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_212_3127",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.86555,
    result: "effect2_foregroundBlur_212_3127"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_212_3127",
    x: -11.4875,
    y: -12.6411,
    width: 128.311,
    height: 92.3109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 9.32773
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_212_3127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_212_3127",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_212_3127",
    x: 49.3789,
    y: 22.0222,
    width: 35.3406,
    height: 5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_212_3127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_212_3127",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_212_3127",
    x: 49.8789,
    y: 31.0522,
    width: 34.3406,
    height: 4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_212_3127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_212_3127",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_212_3127",
    x: 49.8789,
    y: 39.1083,
    width: 23.2637,
    height: 4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_212_3127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_212_3127",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_212_3127",
    x: 20.8647,
    y: 19.9008,
    width: 19.5171,
    height: 27.0339,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_212_3127"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_212_3127",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_212_3127",
    x1: 51.9654,
    y1: 13.0966,
    x2: 51.9654,
    y2: 51.9555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83109C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#330B96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_212_3127",
    x1: 52.668,
    y1: 6.0144,
    x2: 52.668,
    y2: 61.0144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83109C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#330B96"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_212_3194",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 92,
    height: 56
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 56,
    rx: 8,
    fill: "#D9D9D9"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_212_3194)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_if_212_3194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109 -20L109.947 38.1098L126.537 -17.5896L111.771 38.6208L142.773 -10.5373L113.389 39.6049L156.504 0.634045L114.682 40.9892L166.713 15.0958L115.553 42.6709L172.64 31.7754L115.939 44.5254L173.848 49.4358L115.81 46.415L170.247 66.7672L115.175 48.1998L162.103 82.4842L114.083 49.7472L150.021 95.4212L112.614 50.9425L134.896 104.619L110.876 51.6971L117.851 109.395L109 51.955L100.149 109.395L107.124 51.6971L83.1039 104.619L105.386 50.9425L67.9793 95.4212L103.917 49.7472L55.897 82.4842L102.825 48.1998L47.753 66.7672L102.19 46.415L44.1515 49.4358L102.061 44.5254L45.3595 31.7754L102.447 42.6709L51.2875 15.0958L103.318 40.9892L61.4957 0.634045L104.611 39.6049L75.227 -10.5373L106.229 38.6208L91.4632 -17.5896L108.053 38.1098L109 -20Z",
    fill: "white",
    fillOpacity: 0.95
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_if_212_3194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.12895 -63.529L3.87362 -28.6074L20.1225 -59.6894L7.56619 -26.9411L31.5984 -52.4865L10.6722 -24.3402L40.7053 -42.4546L12.9614 -20.9978L46.768 -30.3376L14.264 -17.1618L49.3367 -17.0343L14.4832 -13.1165L48.221 -3.5313L13.603 -9.16217L43.5036 9.16998L11.6885 -5.59193L35.5344 20.1275L8.88176 -2.6706L24.9044 28.5286L5.39094 -0.614847L12.4019 33.7503L1.47494 0.422861L-1.04567 35.4052L-2.57582 0.365565L-14.4411 33.3706L-6.46091 -0.782492L-26.7908 27.7974L-9.89218 -2.93616L-37.179 19.099L-12.6152 -5.9357L-44.8351 7.92044L-14.4279 -9.55867L-49.1914 -4.90919L-15.1959 -13.5364L-49.9247 -18.4384L-14.8624 -17.5738L-46.9807 -31.6637L-13.4518 -21.3714L-40.5778 -43.6043L-11.069 -24.6477L-31.1907 -53.3747L-7.89066 -27.1597L-19.5157 -60.2501L-4.15244 -28.721L-6.41874 -63.7207L-0.131609 -29.2158L7.12895 -63.529Z",
    fill: "white",
    fillOpacity: 0.95
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_if_212_3194",
    x: 41.1516,
    y: -23,
    width: 135.697,
    height: 135.395,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.65098 0 0 0 0 0.85098 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_212_3194"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect2_foregroundBlur_212_3194"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_if_212_3194",
    x: -53.9248,
    y: -67.7207,
    width: 107.261,
    height: 107.126,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.65098 0 0 0 0 0.85098 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_212_3194"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect2_foregroundBlur_212_3194"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfidDocumentFlash);
export default __webpack_public_path__ + "static/media/bfid-document-flash.6907f43b805b180c874d2f68870ecdf3.svg";
export { ForwardRef as ReactComponent };